import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Plus } from 'seagull/icons';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { newClientText, OptionType } from '~/integrations/Accounting/AccountingCustomerDropdown/AccountingCustomerDropdown.utils';
import styles from './AccountingCustomerDropdown.module.scss';
export default function AccountingCustomerDropdown(props) {
    const { accountingCustomers, value, onChange, textFieldProps = {}, loading = false, disabled = false, onInputFocus, onInputBlur, accounting } = props;
    const createNewOption = {
        type: OptionType.CreateNew
    };
    const { testIdPrefix, name } = getAccountingDetails(accounting);
    const onAccountingCustomerChange = (newOption)=>{
        onChange && onChange(newOption);
    };
    return /*#__PURE__*/ _jsx(Autocomplete, {
        testId: "".concat(testIdPrefix, "-customer-dropdown"),
        value: value,
        options: [],
        lazyOptions: ()=>{
            const options = accountingCustomers.map((c)=>({
                    type: OptionType.Existing,
                    customer: c
                }));
            options.unshift(createNewOption);
            return options;
        },
        onChange: (_, newOption)=>onAccountingCustomerChange(newOption || undefined),
        disabled: disabled,
        virtualizeOptions: true,
        renderOption: (option)=>{
            switch(option === null || option === void 0 ? void 0 : option.type){
                case OptionType.CreateNew:
                    {
                        return /*#__PURE__*/ _jsxs(Typography, {
                            skin: "link",
                            className: styles.newClientOption,
                            children: [
                                /*#__PURE__*/ _jsx(Plus, {}),
                                newClientText
                            ]
                        });
                    }
                case OptionType.Existing:
                    {
                        const emailAddress = option.customer.emailAddress();
                        return /*#__PURE__*/ _jsxs("div", {
                            className: styles.existingClientOption,
                            children: [
                                /*#__PURE__*/ _jsxs(Typography, {
                                    ellipsis: true,
                                    testId: "first-line",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            as: "span",
                                            children: option.customer.displayName()
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            as: "span",
                                            weight: "light",
                                            variant: "paragraph2",
                                            skin: "secondary",
                                            children: " (".concat(option.customer.customerName(), ")")
                                        })
                                    ]
                                }),
                                emailAddress && /*#__PURE__*/ _jsx(Typography, {
                                    ellipsis: true,
                                    weight: "light",
                                    variant: "paragraph2",
                                    testId: "second-line",
                                    skin: "secondary",
                                    children: emailAddress
                                })
                            ]
                        });
                    }
            }
        },
        getOptionSelected: (option, value)=>{
            if (!value) return false;
            const isExistingCustomerType = option.type === OptionType.Existing && value.type === OptionType.Existing;
            const existingSelected = isExistingCustomerType && option.customer.id() === value.customer.id();
            const isNewCustomerType = option.type === OptionType.CreateNew && value.type === OptionType.CreateNew;
            return existingSelected || isNewCustomerType;
        },
        getOptionLabel: (option)=>{
            switch(option === null || option === void 0 ? void 0 : option.type){
                case OptionType.CreateNew:
                    {
                        return newClientText;
                    }
                case OptionType.Existing:
                    {
                        return option.customer.formattedDisplay();
                    }
            }
        },
        filterOptions: (options, param)=>{
            let { inputValue } = param;
            const filtered = matchSorter(options, inputValue, {
                keys: [
                    (opt)=>opt.type === OptionType.Existing ? [
                            opt.customer.displayName(),
                            opt.customer.customerName(),
                            opt.customer.emailAddress()
                        ] : []
                ]
            });
            filtered.unshift(createNewOption);
            return filtered;
        },
        noOptionsText: "No ".concat(name, " customers"),
        loading: loading,
        textFieldProps: _object_spread({
            placeholder: 'Not mapped'
        }, textFieldProps),
        selectOnFocus: true,
        disableClearable: false,
        multiple: false,
        freeSolo: false,
        onFocus: onInputFocus,
        onBlur: onInputBlur
    });
}
